import React from 'react'
import { Section } from '@shared/components/section'
import cx from 'classnames'

import { ItemDescription, ProductListLoan } from './ItemDescription'

import styles from './style.module.scss'

const defaultProductList: ProductListLoan[] = [
	{
		id: 1,
		title: <>Банковская ставка&nbsp;&mdash; от&nbsp;13,9%&nbsp;годовых</>,
		description: ['Без страховок', <>Залог&nbsp;&mdash; квартира</>, 'Лояльны к кредитной истории'],
	},
	{
		id: 2,
		title: <>Срок&nbsp;&mdash; до&nbsp;20&nbsp;лет</>,
		description: ['Заёмщик — физическое и юридическое лицо', 'Решение за 1 рабочий день'],
	},
	{
		id: 3,
		title: <>От&nbsp;200&nbsp;тысяч до&nbsp;15&nbsp;млн&nbsp;₽</>,
		description: ['170+ городов России'],
	},
]

interface Props {
	productList?: ProductListLoan[]
	footerBlock?: React.ReactNode
}

export const View = ({ productList = defaultProductList, footerBlock }: Props) => {
	return (
		<Section fullWidth className={styles.wrapper} contentClassName={styles.content}>
			<div className={cx(styles.whiteBox, !footerBlock && styles.whiteBoxOnly)}>
				<h4 className={styles.lightText}>Наш продукт</h4>
				<h2 className={styles.h2}>Займы под залог квартир</h2>
				<ul className={cx(styles.productList)}>
					{productList.map((item: ProductListLoan) => (
						<ItemDescription key={item.id} item={item} />
					))}
				</ul>
			</div>
			{footerBlock}
		</Section>
	)
}
